/*
 * @Author: 丨小小风离丨
 * @Date: 2023-12-12 15:18:17
 * @LastEditTime: 2025-07-09 19:55:22
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\util\network\axios.ts
 * @Description: 
 */
import axios, { Axios, AxiosRequestConfig, AxiosRequestHeaders } from "axios";
import qs from "qs";
// import 'antd/dist/antd.css'
import store from "../../store";
import { message } from "antd";
import { getUserId, getSchoolId } from "../public";

// 判断是否为开发环境设置对应后台地址

let tempUrl = 'http://192.168.129.208:8081'

tempUrl = 'https://xdtest.aiedu100.com'
tempUrl = 'http://192.168.122.200:33101'
// tempUrl = 'http://www.mczjjt.com:8080'
// tempUrl = 'http://isca.lancooedu.com'
// tempUrl = 'http://192.168.129.129:22101'
// tempUrl = 'https://sch.aiedu100.com'
// tempUrl = 'http://iscc.lancooedu.com'
// tempUrl = 'http://192.168.129.208:22101'

let baseURL = process.env.NODE_ENV === "development" ? `${tempUrl}/enrollment` : "/enrollment";


// 默认请求超时时间
const timeout = 30000;
const instance = axios.create({
  // 请求头默认设置
  baseURL,
  timeout,
  headers: {
    userid: getUserId(),
    schoolId: getSchoolId(),
  },
});

const instanceOut = (url: string) => {

  return axios.create({
    // 请求头默认设置
    timeout,
    // url:"https://hailiangedu.com"+url,
    url,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

store.subscribe(() => {
  instance.interceptors.request.use(
    (config: any) => {
      //配置自定义请求头
      let customHeaders: AxiosRequestHeaders = {
        ...config.headers,
        userid: getUserId() || '',
        schoolId: getSchoolId(),
      };


      config.headers = customHeaders;
      // 设置请求头
      if (process.env.REACT_PROJCT_TYPE === 'java') {
        Object.keys(customHeaders).forEach((key) => {
          const value = encodeURIComponent(customHeaders[key]);
          config.headers[key] = value;
        });
      }
      config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json;charset=UTF-8';

      if (config.method === "post") {
        config.params = {
          _: Date.parse(new Date() as unknown as string),
        };
      } else if (config.method === "get") {
        config.params = {
          ...config.params,
          _: Date.parse(new Date() as unknown as string),
        };
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
});

// 定义返回接口
interface axiosTypes<T> {
  code?: any;
  data: T;
  status: number;
  msg: string;
  timestamp?: string;
}

let lastCallTime = 0;

const displayTimeoutWarningMessage = (msg) => {
  const currentTime = Date.now();
  if (currentTime - lastCallTime >= 3000) {
    message.warning(msg);
    lastCallTime = currentTime;
  }
};

// promise化操作，调用then获取相应数据
const requestHandle = <T>(
  method: "get" | "post" | "delete" | "put" | "patch" | "getdown",
  url: string,
  params: any,
  config: AxiosRequestConfig = {},
  axiosInit: Axios = instance
): Promise<T> => {
  let response: Promise<axiosTypes<axiosTypes<T>>>;
  switch (method) {
    case "get":
      response = axiosInit.get(url, { params: { ...params }, ...config });
      break;
    case "getdown":
      response = axiosInit.get(url, { params: { ...params }, ...config });
      break;
    case "post":
      response = axiosInit.post(url, params, { ...config });
      break;
    case "delete":
      response = axiosInit.delete(url, { params: { ...params }, ...config });
      break;
    case "put":
      // 旧请求
      response = axiosInit.put(url, { ...params }, { ...config });
      // 新请求
      break;
    case "patch":
      response = axiosInit.patch(
        url,
        qs.stringify(params, { indices: false }),
        {
          ...config,
        }
      );
      break;
  }
  return new Promise<T>((resolve, reject) => {
    response
      .then((res) => {
        const data: any = res.data;
        if (method === "getdown") {
          resolve(data);
        } else {
          if (
            data.status === 200 || data.status === 0 ||
            data.code === 200 || data.code === 0
          ) {
            resolve(data);
          } else {
            if (data.status !== 0 || data.code !== 0) {
              reject(data);
            } else {
              resolve(data?.data || data);
            }
          }
        }
      })
      .catch((error) => {

        let msg = "请检查网络状态是否正常";
        if (
          error.status === "ECONNABORTED" ||
          error.message === "Network Error" ||
          error.message.includes("timeout")
        ) {
          displayTimeoutWarningMessage("请求超时，请稍后重试！")
          let e: any = JSON.stringify(error);
          reject(e);
        } else {
          console.log(error, 'error');
          switch (error?.response?.status) {
            case 405:
              msg = "非法请求";
              break;
            case 500:
              msg = "请联系管理员解决问题";
              break;
            default:
              // msg='请检查网络状况是否良好'
              break;
          }
          let e: any = JSON.stringify(error);
          displayTimeoutWarningMessage(`网络错误: ${msg}`)
          reject(e);
        }
      });
  });
};

// 总体request 统一调用 包括封装的get post put delete等
const request = {
  get: <T>(
    url: string,
    params?: object,
    config?: AxiosRequestConfig,
    axiosInit?: Axios
  ) => requestHandle<T>("get", url, params, config, axiosInit),
  getDown: <T>(
    url: string,
    params?: object,
    config?: AxiosRequestConfig,
    axiosInit?: Axios
  ) => requestHandle<T>("getdown", url, params, config, axiosInit),
  post: <T>(
    url: string,
    params?: object,
    config?: AxiosRequestConfig,
    axiosInit?: Axios
  ) => requestHandle<T>("post", url, params, config, axiosInit),
  delete: <T>(
    url: string,
    params?: object,
    config?: AxiosRequestConfig,
    axiosInit?: Axios
  ) => requestHandle<T>("delete", url, params, config, axiosInit),
  put: <T>(
    url: string,
    params?: object,
    config?: AxiosRequestConfig,
    axiosInit?: Axios
  ) => requestHandle<T>("put", url, params, config, axiosInit),
  patch: <T>(
    url: string,
    params?: object | string,
    config?: AxiosRequestConfig,
    axiosInit?: Axios
  ) => requestHandle<T>("patch", url, params, config, axiosInit),
};

// 同步请求
const asyncConfig = axios.create({
  baseURL,
  timeout,
});

asyncConfig.interceptors.request.use(
  (config: any) => {
    //配置自定义请求头
    let customHeaders: any = {
      language: "zh-cn1",
      userid: getUserId() || '',
      schoolId: getSchoolId(),
      // userId: userdata?.UserID || "",
    };
    config.headers = customHeaders;
    // 设置请求头
    if (process.env.REACT_PROJCT_TYPE === 'java') {
      Object.keys(customHeaders).forEach((key) => {
        const value = encodeURIComponent(customHeaders[key]);
        config.headers[key] = value;
      });
    }

    config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json;charset=UTF-8';
    return config;
  },
  (error) => {
    console.log(error, 'error');
    return Promise.reject(error);
  }
);

// // 添加响应拦截器
asyncConfig.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export { request, asyncConfig, baseURL, instanceOut };
